import React from "react";
import { InteractiveTooltip } from "@my-scoot/component-library-legacy";
import { Button } from "@my-scoot/component-library-legacy";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { openPricingPage } from "utils/Utils";
import { LockOutlined } from "@material-ui/icons";

const UpgradeTooltip = ({ children, open, displayTitle = "", placement }) => {
  const isSeeReferenceModalOpen = useAdminPanelStore(
    (state) => state.isSeeReferenceModalOpen
  );

  return (
    <InteractiveTooltip
      open={open && !isSeeReferenceModalOpen}
      totalSteps={0}
      title={
        <div className="tw-text-md tw-mb-4 tw-whitespace-pre-line tw-flex tw-flex-col tw-justify-center tw-items-center tw-text-center !tw-text-[#7F5400] tw-font-[500] tw-gap-2">
          <LockOutlined className="!tw-text-[#7F5400] !tw-mt-1" />
          <div>{displayTitle}</div>
        </div>
      }
      primaryBtnText="Upgrade Plan"
      customFooter={
        <div className="tw-flex tw-justify-center">
          <Button
            onClick={openPricingPage}
            className="tw-text-sm !tw-h-8 !tw-py-2 !tw-bg-[#F7AD1E] !tw-font-[700]"
            fullWidth
          >
            Upgrade Plan
          </Button>
        </div>
      }
      tooltipClasses={{
        popperArrow: "",
        tooltipArrow: "!tw-bg-[#FFF7E7] !tw-border-[#F7AD1E] !tw-rounded-md",
        tooltipPlacementRight: null,
        tooltipPlacementBottom: null,
      }}
      arrowClassName="!tw-text-[#FFF7E7] !tw-border-[#F7AD1E]"
      placement={placement ? placement : "bottom"}
    >
      <div className="tw-cursor-pointer">{children}</div>
    </InteractiveTooltip>
  );
};

export default UpgradeTooltip;
